// extracted by mini-css-extract-plugin
module.exports = {"anchor-menu-mobile__section-header-drawer":"anchor-menu-mobile_anchor-menu-mobile__section-header-drawer__eOEQx"};